import React from "react";
import { useField } from "react-final-form";
import { TextInput } from "@truevault/aquilo";
import { CONSENT_INPUT_TEXT_SIZE } from "../../../consentBanner/consentFieldStyles";
import {
  ConsentCaption,
  ConsentLinkButton,
  ConsentSettingRow,
} from "../../../consentBanner/ConsentSettingRow";
import { INFORMATIONAL_BANNER_ACCEPT_BUTTON_DEFAULT_TEXT } from "../../../../superorg/settings/ConsentBannerSettings";

const MAX_LENGTH = 48;

interface ConsentBannerUSButtonRowProps {
  formApi: { change: (field: string, value: string) => void };
  helpText?: string;
}

export const ConsentBannerUSButtonRow = ({ formApi, helpText }: ConsentBannerUSButtonRowProps) => {
  const { input } = useField<string>("informationalBannerAcceptButtonText", {
    subscription: { value: true },
  });

  return (
    <ConsentSettingRow
      title="Accept button"
      helpText={
        helpText ?? "The button that dismisses the informational banner or the opt-out banner."
      }
    >
      <div className="w-full max-w-[240px]">
        <TextInput
          field="informationalBannerAcceptButtonText"
          inputTextSize={CONSENT_INPUT_TEXT_SIZE}
          aria-label="Accept button text"
          maxLength={MAX_LENGTH}
          required
        />
      </div>
      <div className="flex flex-wrap items-center gap-x-[16px] gap-y-[4px]">
        <ConsentCaption>
          {(input.value ?? "").length}/{MAX_LENGTH}
        </ConsentCaption>
        <ConsentLinkButton
          onClick={() =>
            formApi.change(
              "informationalBannerAcceptButtonText",
              INFORMATIONAL_BANNER_ACCEPT_BUTTON_DEFAULT_TEXT,
            )
          }
        >
          Reset to default
        </ConsentLinkButton>
      </div>
    </ConsentSettingRow>
  );
};
